import React from 'react';
import AdminMain from './components/Admin/AdminMain/AdminMain';
import Login from './components/Layouts/Login/Login';
import Signup from './components/Layouts/Signup/AdminSignup';
import UserMain from './components/User/UserMain/UserMain';
import UserSignup from './components/Layouts/Signup/UserSignup';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect
} from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";

export default function Routes() {
    return (
        <Router>
            <Switch>

                <Route exact path="/">
                    <Redirect to="/login" />
                </Route>

                <Route path="/login">
                    <Login />
                </Route>

                <Route exact path="/signup">
                    <Signup />
                </Route>

                <Route path="/:tenantID/signup">
                    <UserSignup />
                </Route>

                <Route path="/:tenantID/admin">
                    <AdminMain />
                </Route>

                <Route path="/:tenantID/user">
                    <UserMain />
                </Route>

                <Route path="/customer">
                </Route>

            </Switch>
        </Router>
    )
}
